export default {
  data: function () {
    return {
      img: (this.randomImg =
        "/media/errors/error/" + this.getRandomInt(0, 3) + ".gif"),
    }
  },
  props: ["error"],
}
